// Vue
import {Vue, Component, Prop, Inject, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

export interface Item {
    id: number,
    href: string,
    target: string,
    icon: string,
    text: string,
    active: boolean
}

@Component({
    mixins: [template]
})
export class NextStepNavigation extends Vue {

    @Prop({default: () => []})
    private items!: Item[]

    // For CMS only
    @Prop({default: false})
    private editMode!: boolean

    @Watch('items')
    public onItemsChange() {
        if (this.items.length > 0) {
            this.animate()
        }
    }

    public mounted() {
        this.animate()
    }

    private animate() {
        // Start the animation
        // Note: We do not use Vue States for this because the rerendering needs to much time
        // and therefore destorys the animation.
        this.$nextTick(() => {
            let elements = <HTMLElement[]>this.$refs['element']

            const duration = 150;
            const className = `${this.$appPrefix}-next-step-navigation__element--activate`;

            if (elements) {
                // Make activation animation
                elements.forEach((element, index) => {
                    setTimeout(() => {
                        element.classList.add(className)
                    }, (index + 1) * duration)
                });

                // End activation animation
                setTimeout(() => {
                    elements.forEach((element) => {
                        element.classList.remove(className)
                    })
                }, Math.max(2000, (elements.length + 2) * duration))
            }
        })
    }
}
